import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import styles from '../styles/index.module.less';

function TutorialsButton(props, ref) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { menu, isHovered, ...rest } = props;

  return (
    <button
      {...rest}
      aria-expanded={menu.children?.length > 0 ? isHovered : undefined}
      aria-haspopup={menu.children?.length > 0 ? 'menu' : undefined}
      ref={ref}
      type="button"
      className={`${styles.btn} ${isHovered ? styles.btnActive : ''}`}
    >
      <span
        onClick={() => {
          if (!menu.path || menu.children?.length > 0) return;
          if (menu.path.startsWith('http')) window.open(menu.path, '_blank');
          else navigate(menu.path);
        }}
      >
        {menu.title === 'dataCenterMode' ? t('common:feature.navigation') : menu.title || t('common:feature.navigation')}
      </span>
    </button>
  );
}

const TutorialsButtonComponent = forwardRef(TutorialsButton);
export { TutorialsButtonComponent as TutorialsButton };
